export default {
  message: {
    "error": "یک خطا رخ داد!",
    "Sorrysomeerrorsoccurred": "متاسفانه خطاهایی رخ داد",
    "quit": "خروج",
    "language": "زبان",
    "Youcanchangethelanguagehere": "شما می‌توانید زبان را در اینجا تغییر دهید!",
    "current": "فعلی",
    "home": "خانه",
    "friends": "دوستان",
    "wallet": "کیف پول",
    "aboutus": "درباره ما",
    "Sharewithfriends": "با دوستان به اشتراک بگذارید",
    "copyFailure": "کپی ناموفق",
    "copySuccess": "کپی موفق",
    "Claimreward": "دریافت پاداش",
    "DailyLogin": "ورود روزانه",
    "noInvitationsYet": "هنوز دعوتنامه‌ای نیست",
    "LoadMore": "بارگذاری بیشتر",
    "WatchAD": "تبلیغ را تماشا کنید",
    "continue": "ادامه",
    "Congratulations": "تبریک",
    "MyFriends": "دوستان من",
    "Invitefriends": "دوستان را دعوت کنید",
    "Invitepremiumfriends": "دوستان ویژه را دعوت کنید",
    "DailyTasks": "وظایف روزانه",
    "inviteDesc": "+{num} ${name} برای هر دوستی که دعوت کنید",
    "DailyTasksDesc": "وظایف را کامل کنید تا ${name} بیشتری بگیرید",
    "SponsorsandPartners": "حامیان و شرکا",
    "Receivingwallet": "کیف پول دریافتی",
    "Enterwalletaddress": "آدرس کیف پول {name} را وارد کنید",
    "Claim": "دریافت",
    "Booster": "افزایش‌دهنده",
    "RentPeriod": "دوره اجاره",
    "days30": "30 روز",
    "days": "روز",
    "Dailyprofit": "سود روزانه",
    "Totalprofit": "سود کلی",
    "Quantity": "مقدار",
    "RentPrice": "قیمت اجاره",
    "RentMiner": "اجاره ماینر",
    "Insufficient": "مقدار کافی نیست ${name}",
    "InsufficientMsg": "{num} ${name1} مورد نیاز است، دوستان را دعوت کنید یا وظایف را کامل کنید تا ${name2} بیشتری کسب کنید.",
    "Settings": "تنظیمات",
    "copyid": "کپی شناسه",
    "UpgradeSuccessfully": "به‌روزرسانی با موفقیت",
    "Name": "نام",
    "userinfo": "اطلاعات کاربری",
    "disconnect": "قطع ارتباط",
    "Startmining": "شروع استخراج",
    "Welcome": "به {name} خوش آمدید",
    "Withdrawal": "برداشت",
    "Minimumamount": "حداقل مقدار",
    "Networkfee": "هزینه شبکه",
    "Enteramount": "مقدار را وارد کنید",
    "Submit": "ارسال",
    "MinimumTip": "مقدار برداشت خیلی کوچک است. حداقل مقدار برداشت: {num}",
    "MaximumTip": "مقدار کافی نیست، حداکثر مقدار که می‌توانید برداشت کنید: {num}",
    "SubmittedTip": "ارسال شد، انتظار می‌رود ظرف ۳۰-۶۰ روز کاری پردازش شود",
    "WithdrawStatus": "وضعیت",
    "Submissiontime": "زمان ارسال",
    "WithdrawAwaitTip": "* تخمین زده می‌شود ۳۰-۶۰ روز کاری طول بکشد. دعوت از دوستان بیشتر می‌تواند روند بررسی را تسریع کند.",
    "Processing": "در حال پردازش",
    "Amount": "مقدار",
    "Numberoffriends": "تعداد دوستان: {now}/{limit}",
    "InviteTip": "برای انجام اولین برداشت خود، نیاز به دعوت {limit} دوست دارید تا به اپلیکیشن استخراج بپیوندند.",
    "openonphone": "این لینک را در گوشی خود باز کنید.",
    "claimTip": "مقدار قابل دریافت خیلی کوچک است. حداقل مقدار قابل دریافت: {num}",
    "WalletBalance": "موجودی کیف پول",
    "Withdraw": "برداشت",
    "SetWalletAddress": "تنظیم آدرس کیف پول",
    "WithdrawalRecord": "سابقه برداشت",
    "Norecords": "بدون سوابق",
    "Whatis": "{name} چیست؟",
    "All": "همه",
    "save": "ذخیره",
    "successWithdrawal": "برداشت دریافت شده {num}",
    "secondsago": "{time} ثانیه پیش",
    "Loading": "در حال بارگذاری...",
    "PaymentConfirming": "در حال بررسی وضعیت تراکنش...",
    "Check": "بررسی",
    "CheckFail": "تراکنش تکمیل نشده است. لطفا دوباره در ۵ ثانیه بررسی کنید.",
    "Addname": "به نام خود '{name}' را اضافه کنید",
    "Restattcheck": "برای بررسی مجدد، اپلیکیشن را راه‌اندازی مجدد کنید",
    "Copyname": "کپی '{name}'",
    "SubmissionFailed": "ارسال ناموفق، لطفا بعداً دوباره تلاش کنید",
    "WithdrawalReview": "بررسی برداشت",
    "WebWithdrawAwaitTip": "* تخمین زده می‌شود ۲۴-۴۸ ساعت طول بکشد. دعوت از دوستان بیشتر می‌تواند روند بررسی را تسریع کند.",
    "Success": "موفقیت",
    "Rejection": "رد‌شده",
    "WebSubmittedTip": "ارسال شد، انتظار می‌رود ظرف ۲۴-۴۸ ساعت پردازش شود",
    "shop": "خرید",
    "topurchase": "به فروشگاه بروید تا خرید کنید",
    "shopDesc": "موجودی محدود—زودتر اقدام کنید قبل از اینکه ناپدید شود!",
    "claim": "جمع‌آوری جوایز",
    "payment_success": "پرداخت موفق",
    "payment_failed": "پرداخت ناموفق",
    "payment_cancelled": "پرداخت لغو شد",
    "opening_payment": "در حال باز کردن پرداخت...",
    "payment_status": "وضعیت پرداخت",
    "create_order_failed": "ایجاد سفارش ناموفق بود",
    "creating_ton_order": "در حال ایجاد سفارش TON...",
    "next_step": "مرحله بعدی",
    "use_ton_payment": "استفاده از پرداخت TON",
    "start_transaction": "شروع تراکنش",
    "connect_wallet": "اتصال کیف پول",
    "address": "آدرس",
    "amount_ton": "مقدار TON",
    "copy": "کپی",
    "amount": "مقدار",
    "wallet_address": "آدرس کیف پول",
    "comment_memo": "یادداشت توضیحی",
    "you_can_choose_to_connect_wallet_to_pay": "شما می‌توانید انتخاب کنید که برای پرداخت کیف پول را متصل کنید",
    "or_manually_transfer_to_the_above_address": "یا به صورت دستی به آدرس بالا انتقال دهید (توجه داشته باشید که مقدار و یادداشت باید دقیقاً یکسان باشد)",
    "transaction_success": "تراکنش موفق",
    "transaction_failed": "تراکنش ناموفق",
    "transaction_error": "خطای تراکنش",
    "transaction_status": "وضعیت تراکنش",
    "transaction_id": "شناسه تراکنش",
    "transaction_amount": "مقدار تراکنش",
    "transaction_status_desc": "توضیحات وضعیت تراکنش",
    "payment_status_tip": "لطفاً برای تأیید پرداخت منتظر بمانید",
    "select_payment_method": "روش پرداخت را انتخاب کنید",
    "total_amount": "مجموع مبلغ",
    "creating_order": "در حال ایجاد سفارش...",
    "order_created": "سفارش ایجاد شد",
    "order_status": "وضعیت سفارش",
    "Applyforwithdrawal": "درخواست برداشت",
    "Withdrawalunlock": "باز شدن قفل برداشت",
    "WithdrawalunlockTip": "شما به {num} دوستان دعوت‌شده نیاز دارید تا وظایف را کامل کنید/کیف پول‌ها را متصل کنید تا برداشت را باز کنید",
    "Close": "بستن",
    "Delivering": "در حال تحویل",
    "Duetothelargenumber": "به دلیل تعداد زیاد دریافت‌کنندگان، انتظار می‌رود ایردراپ شما در ۱۵-۲۰ روز کاری برسد",
    "select_network": "شبکه را انتخاب کنید",
    "confirm": "تایید",
    "switching_network": "تغییر شبکه...",
    "network_switched": "شبکه تغییر یافت",
    "use_usdt_payment": "روش پرداخت USDT",
    "or_manually_transfer_to_the_above_address_usdt": "به آدرس بالا به صورت دستی منتقل کنید (توجه داشته باشید که مقدار و آدرس باید دقیقا یکسان باشد)",
    "chain_type": "شبکه",
    "check_transaction_status": "بررسی وضعیت تراکنش",
    "transaction_wait": "تراکنش در حال پردازش است. شما می‌توانید از برنامه خارج شوید. یک پیام به شما اطلاع خواهد داد زمانی که کامل شد.",
    "twa_pay_tip_with_memo": "لطفاً اطمینان حاصل کنید که آدرس، مبلغ و یادداشت برای انتقال یکسان باشند.",
    "twa_pay_tip": "لطفاً اطمینان حاصل کنید که آدرس و مبلغ برای انتقال صحیح هستند.",
    "creating_usdt_order": "درحال ایجاد سفارش USDT...",
    "affiliate_programs": "برنامه‌های همکاری",
    "affiliate_programs_description": "دوستان خود را دعوت کنید تا به اپلیکیشن استخراج بپیوندند و جوایز دریافت کنند.",
    "commission_details": "جزئیات کمیسیون",
    "no_commission_records": "سابقه کمیسیون موجود نیست",
    "commission_list": "لیست کمیسیون",
    "input_amount": "مقدار ورودی",
    "max": "حداکثر",
    "commission_input_amount": "مقدار کمیسیون ورودی را وارد کنید",
    "min_commission": "حداقل مبلغ برداشت {num} است",
    "WithdrawalSuccess": "برداشت موفق",
    "WithdrawalFailed": "برداشت ناموفق",
    "WithdrawalProcessing": "برداشت در حال پردازش",
    "award": "جایزه",
    "level": "سطح",
    "Share_to_group": "به گروه به اشتراک بگذارید",
    "Exchange": "تبادلات",
    "balance_not_enough": "اعتبار کافی نیست، شما می‌توانید فقط {num} {coin} را تبادل کنید",
    "exchange_fail": "تبادل ناموفق",
    "exchange_success": "تبادل موفق",
    "you_will_receive": "شما دریافت خواهید کرد",
    "ShareToGroups": "به گروه‌ها به اشتراک بگذارید",
    "Numberofgroups": "تعداد گروه‌ها: {now}/{limit}",
    "Confirm": "تأیید",
    "ShareToGroupsDesc": "برای دریافت بیشتر {name} به گروه‌ها به اشتراک بگذارید",
    "TokenAddress": "لطفاً جزئیات برداشت مانند شناسه صرافی یا آدرس USDT را وارد کنید",
    "CashAddress": "لطفاً جزئیات برداشت مانند شماره کارت بانکی یا آدرس USDT را وارد کنید",
    "Cancel": "لغو",
    "min_withdrawal_amount": "حداقل مبلغ برداشت {num} {coin} است",
    "max_withdrawal_amount": "حداکثر مبلغ برداشت {num} {coin} است",
    "withdrawal_failed": "برداشت ناموفق بود",
    "withdrawal_success": "برداشت با موفقیت انجام شد",
    "PayNow": "الان پرداخت کنید",
    "PaySkip": "پرداخت {num} برای باز کردن برداشت به صورت آنی",
    "NumberofGroups": "تعداد گروه‌ها: {now}/{limit}",
    "SendMessage": "ارسال پیام",
    "NumberofShares": "تعداد سهم‌ها: {now}/{limit}",
    "NumberofTasks": "تعداد وظایف: {now}/{limit}",
    "CompleteTask": "وظیفه را کامل کنید",
    "PleaseEnterValidAmount": "لطفاً مبلغ معتبر وارد کنید",
    "PleaseEnterValidEmail": "لطفاً ایمیل معتبر وارد کنید",
    "Feedback": "بازخورد",
    "Inputfeedbackcontent": "محتوای بازخورد را وارد کنید",
    "Submitfeedback": "بازخورد را ارسال کنید",
    "Pleaseenteravalidemailaddress": "لطفاً یک آدرس ایمیل معتبر وارد کنید",
    "Pleaseenteryouremailaddress": "لطفاً آدرس ایمیل خود را وارد کنید",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "شما امروز قبلاً بازخورد داده‌اید، لطفاً فردا برگردید",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "بازخورد با موفقیت ارسال شد، از بازخورد ارزشمند شما سپاسگزاریم",
    "Feedback_submission_failed_please_retry": "ارسال بازخورد ناموفق بود، لطفاً دوباره تلاش کنید",
    "ContactUs": "با ما تماس بگیرید",
    "XRPAddress": "لطفاً آدرس کیف پول زنجیره‌ای XRP فعال شده را پر کنید (شامل MEMO)، در غیر این صورت نمی‌توانید وجه نقد برداشت کنید.",
    "Accelerated": "شتاب‌زده",
    "Accelerated_withdrawals_success": "برداشت‌های شتاب‌زده با موفقیت",
    "login": "وارد شدن",
    "register": "ثبت نام",
    "login_with_google": "وارد شدن با گوگل",
    "or": "یا",
    "email": "ایمیل",
    "password": "رمز عبور",
    "no_account": "حساب کاربری ندارید",
    "click_to_go": "برای",
    "have_account": "حساب کاربری دارید",
    "go_to": "برو به",
    "invite_code": "کد دعوت",
    "optional": "اختیاری",
    "google_login_not_ready": "ورود به گوگل آماده نیست، لطفاً بعداً امتحان کنید",
    "password_too_long": "رمز عبور خیلی طولانی است",
    "weak": "ضعیف",
    "medium": "متوسط",
    "strong": "قوی",
    "login_success": "وارد شدن با موفقیت",
    "login_failed": "وارد شدن ناموفق بود",
    "please_input_email": "لطفاً ایمیل خود را وارد کنید",
    "invalid_email": "فرمت ایمیل نامعتبر است",
    "please_input_password": "لطفاً رمز عبور خود را وارد کنید",
    "password_length_6_to_16": "رمز عبور باید ۶-۱۶ کاراکتر باشد",
    "account_or_password_error": "خطای حساب یا رمز عبور",
    "register_success": "ثبت نام با موفقیت",
    "register_failed": "ثبت نام ناموفق بود",
    "save_error": "خطای ذخیره، لطفاً بعداً دوباره تلاش کنید",
    "ShareToFriends": "به دوستان به اشتراک بگذارید",
    "login_first": "لطفاً ابتدا وارد شوید",
    "WalletBscError": "❌ نشانی کیف پول BNB Chain نامعتبر است.",
    "DownloadWallet": "کیف پول را دانلود کنید",
    "AddToHomeScreen": "{appName} را به صفحه اصلی اضافه کنید",
    "TapShareInToolbar": "در نوار ابزار ضربه بزنید",
    "SelectAddToHomeScreen": "افزودن به صفحه اصلی را انتخاب کنید",
    "OpenToolbar": "نوار ابزار را باز کنید",
    "ClaimFailed": "دریافت ناموفق، لطفاً بعداً امتحان کنید",
    "guest_login": "ورود مهمان",
    "please_input_phone": "لطفاً شماره تلفن خود را وارد کنید",
    "email_error_1": "لطفاً ایمیل خود را وارد کنید",
    "email_error_2": "لطفاً یک آدرس ایمیل معتبر وارد کنید",
    "email_error_3": "استفاده از ایمیل مهمان مجاز نیست، لطفاً یک ایمیل واقعی استفاده کنید",
    "phone": "تلفن",
    "phone_error_1": "لطفاً شماره تلفن خود را وارد کنید",
    "phone_error_2": "لطفاً یک شماره تلفن معتبر وارد کنید",
    "update_info": "به‌روز رسانی اطلاعات",
    "update_success": "به‌روزرسانی با موفقیت انجام شد",
    "update_failed": "به‌روزرسانی ناموفق بود، لطفاً بعداً دوباره تلاش کنید",
    "cancel": "لغو",
    "guest_credentials_title": "اطلاعات حساب",
    "guest_credentials_warning": "لطفاً یک اسکرین‌شات بگیرید تا حساب و رمز عبور خود را ذخیره کنید. اگر گم شود، درآمد شما قابل بازیابی نیست!",
    "i_have_saved": "من ذخیره کرده‌ام",
    "account": "حساب",
    "view_credentials": "مشاهده اعتبارنامه‌ها",
    "miner_max_reached": "شما به حداکثر تعداد این ماینر دست یافته‌اید"
}};